import { render, staticRenderFns } from "./NewsItems.vue?vue&type=template&id=c60bcc1c&scoped=true&"
import script from "./NewsItems.vue?vue&type=script&lang=js&"
export * from "./NewsItems.vue?vue&type=script&lang=js&"
import style0 from "./NewsItems.vue?vue&type=style&index=0&id=c60bcc1c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60bcc1c",
  null
  
)

export default component.exports